import React from 'react';

import { styled } from '@this/constants/themes';
import { media } from '@this/src/components/shared/atoms/media';
import { HOTEL_PLAN_POINT_NOTICE } from '@this/domain/hotel_element2';
import StayPlanWarning from '@this/src/components/reserve_trip/select/shared/stay_plan_warning';

export interface Translatedline {
  label: string;
  value: string;
  translate: boolean;
  kind?: string;
  restricted?: boolean;
}

interface Props {
  line: Translatedline;
}

const TripCardHotelTypeLine: React.FC<Props> = ({ line }) => {
  return line.restricted ? (
    <RestrictedWrapper>
      <LineText line={line} />
      <StayPlanWarning variant="text" restricted />
    </RestrictedWrapper>
  ) : (
    <LineText line={line} />
  );
};

const LineBreakContainerStyle = { whiteSpace: 'pre-line' as const };

const formatValueWithLineBreaks = (value: string): React.ReactNode => {
  if (value && typeof value === 'string' && value.includes('\n')) {
    return (
      <div style={LineBreakContainerStyle}>
        {value.split('\n').map((lineText: string, lineIndex: number) => (
          <div key={lineIndex}>{lineText}</div>
        ))}
      </div>
    );
  }
  return value;
};

const LineText: React.FC<Props> = ({ line }) => {
  return line.translate ? <TranslatedText line={line} /> : <UnTranslatedText line={line} />;
};

const TranslatedText: React.FC<Props> = ({ line }) => {
  return (
    <Text>
      <span>{line.label}</span>
      <span>{formatValueWithLineBreaks(line.value)}</span>
      {line.kind === 'plan_name' && (
        <div style={{ fontSize: '10px', color: '#7d7d7d' }}>{HOTEL_PLAN_POINT_NOTICE}</div>
      )}
    </Text>
  );
};

const UnTranslatedText: React.FC<Props> = ({ line }) => {
  return (
    <Text>
      <span>{line.label}</span>
      <span data-wovn-ignore>{formatValueWithLineBreaks(line.value)}</span>
      {line.kind === 'plan_name' && (
        <div style={{ fontSize: '10px', color: '#7d7d7d' }}>{HOTEL_PLAN_POINT_NOTICE}</div>
      )}
    </Text>
  );
};

const RestrictedWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 2px 0;
  line-height: normal;

  ${media.sp`
    flex-direction: column;
    gap: 2px;
  `}
`;

const Text = styled.div``;

export default TripCardHotelTypeLine;
